import { APICore } from "./apiCore";

const api = new APICore();

const listarIntervencoes = (query?: string) => {
    return api.get(`/intervencao-externa${query ? query : ''}`);
};

export { listarIntervencoes };
